import { MemberInterface, MemberInviteInterface, MemberInviteStatus } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/Members/Invite/MemberInvite.Controller.ts

export class MemberInviteAPI {
  static async loadInvite(inviteUUID: string) {
    return APIService.Server.get<MemberInviteInterface>(`/member-invite/byid/${inviteUUID}`);
  }
  static async loadInvites(orgId: number) {
    return APIService.Server.get<MemberInviteInterface[]>(`/member-invite/org/${orgId}/invites`);
  }
  static async loadInvitesForAccount(accountId: number) {
    return APIService.Server.get<MemberInviteInterface[]>(`/member-invite/account/${accountId}/invites`);
  }

  static async acceptInvite(invite: MemberInviteInterface, accountId: number) {
    return APIService.Server.put<{
      member: MemberInterface;
      invite: MemberInviteInterface;
    }>(`/member-invite/org/${invite.orgId}/invite-uuid/${invite.uuid}/accept?accountId=${accountId}`);
  }
  static async denyOrRevokeInvite(orgId: number, inviteUUID: string, status: MemberInviteStatus.REVOKED | MemberInviteStatus.DENIED) {
    return APIService.Server.put<MemberInviteInterface>(`/member-invite/org/${orgId}/invite-uuid/${inviteUUID}/${status}`);
  }

  static async updateInvite(orgId: number, inviteId: number, invite: Partial<MemberInviteInterface>) {
    return APIService.Server.put<MemberInviteInterface>(`/member-invite/org/${orgId}/invite/${inviteId}`, invite);
  }

  static async createInvite(orgId: number, invite: Partial<MemberInviteInterface>) {
    return APIService.Server.post<MemberInviteInterface>(`/member-invite/org/${orgId}/invite/`, invite);
  }
  static async resendInvite(orgId: number, inviteUUID: string) {
    return APIService.Server.post<boolean>(`/member-invite/org/${orgId}/invite-uuid/${inviteUUID}/resend`);
  }
}
